import { ActionTypesFactory } from '../../../../utils/utils';

export const CreateGenInfoActionTypes = ActionTypesFactory('creategeninfosave', 'CREATE_GENINFO_SAVE');
export const CreateBankDetailsActionTypes = ActionTypesFactory('createbankdetails', 'Create_bankdetails');
export const CreateDifferentSourcesActionTypes = ActionTypesFactory('createdifferentsources', 'Create_differentsources');
export const GetGenInfoActionTypes = ActionTypesFactory('getgeninfosave', 'GET_GENINFO_SAVE');
export const CreateGenInfoRequestSubmitActionTypes = ActionTypesFactory('creategeninforequestsubmit', 'CREATE_ULTIMATE_SUBMIT');
